import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { NavigationService } from "../../../shared/services/navigation.service";
import { Subscription } from 'rxjs';
import { ThemeService } from '../../../shared/services/theme.service';
import { LayoutService } from '../../services/layout.service';
import { JwtAuthService } from '../../../shared/services/auth/jwt-auth.service';
import { LanguageService, Language } from '../../services/language.service';
import { Utils } from '../../../utils/utils';

@Component({
  selector: 'app-header-top',
  templateUrl: './header-top.component.html',
  styleUrls: ['./header-top.css']
})
export class HeaderTopComponent implements OnInit, OnDestroy {
  utils = Utils;
  layoutConf: any;
  menuItems: any;
  menuItemSub: Subscription;
  langSub: Subscription;
  egretThemes: any[] = [];
  currentLang: Language;
  availableLangs: Language[];
  @Input() notificPanel;

  constructor(
    private layout: LayoutService,
    private navService: NavigationService,
    public themeService: ThemeService,
    public jwtAuth: JwtAuthService,
    private languageService: LanguageService
  ) {}

  ngOnInit() {
    this.layoutConf = this.layout.layoutConf;
    this.egretThemes = this.themeService.egretThemes;
    this.availableLangs = this.languageService.getAvailableLangs();

    this.langSub = this.languageService.currentLang$.subscribe((lang: Language) => {
      this.currentLang = lang;
    });

    this.menuItemSub = this.navService.menuItems$.subscribe(res => {
      res = res.filter(item => item.type !== 'icon' && item.type !== 'separator');
      const limit = 4;
      const mainItems: any[] = res.slice(0, limit);
      if (res.length <= limit) {
        this.menuItems = mainItems;
        return;
      }
      const subItems: any[] = res.slice(limit, res.length - 1);
      mainItems.push({
        name: 'More',
        type: 'dropDown',
        tooltip: 'More',
        icon: 'more_horiz',
        sub: subItems
      });
      this.menuItems = mainItems;
    });
  }

  ngOnDestroy() {
    this.menuItemSub.unsubscribe();
    if (this.langSub) {
      this.langSub.unsubscribe();
    }
  }

  setLang(lang: Language) {
    this.languageService.setLang(lang);
  }

  changeTheme(theme) {
    this.layout.publishLayoutChange({ matTheme: theme.name });
  }

  toggleNotific() {
    this.notificPanel.toggle();
  }

  toggleSidenav() {
    this.layout.publishLayoutChange({
      sidebarStyle: this.layoutConf.sidebarStyle === 'closed' ? 'full' : 'closed'
    });
  }

  get empresaNomeSessao(): string {
    const item = this.jwtAuth.item$?.value;
    const filial = this.jwtAuth.filial$?.value;
    return item?.empresaRemota?.nomeFantasia
      || filial?.nomeFantasia
      || filial?.razaoSocial
      || '';
  }
}
